import React from 'react';
import classNames from 'classnames';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as EmbedCodeDefaultCover } from '../../svg/default-cover/embed-code-default-cover.svg';
import EmbeddableViewer from './EmbeddableViewer';

const useStyles = makeStyles(() => ({
  container: {
    pointerEvents: 'none',
  },
  fullSize: {
    height: '100%',
    width: '100%',
  },
}));

interface Props {
  name?: string;
  url?: string;
}

const EmbeddableCover: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();

  const { name = 'Embed code', url } = props;

  if (!url) {
    return <EmbedCodeDefaultCover className={classes.fullSize} />;
  }

  return (
    <Box className={classNames(classes.container, classes.fullSize)}>
      <EmbeddableViewer name={name} tabIndex={-1} url={url} />
    </Box>
  );
};

export default EmbeddableCover;
